import { axiosInstance } from "@/axios/interceptors";
import {
	InitiatePasswordRecoveryResponseSchema,
	VerifyCodeResponseSchema,
} from "@/features/recover-password/schema";
import { ZodSentryReporter } from "@/lib/zod-sentry-reporter";

export type InitiatePasswordRecoveryPayload = {
	phone: string;
	phone_global_country_id: number;
};

export const initiatePasswordRecovery = async (
	payload: InitiatePasswordRecoveryPayload,
) => {
	const response = await axiosInstance.post("/guests/password_recovery", {
		...payload,
	});
	return ZodSentryReporter.parse(
		InitiatePasswordRecoveryResponseSchema,
		response,
	);
};

export type VerifyCodePayload = {
	code: string;
	guest_id: number;
};

export const verifyCode = async (payload: VerifyCodePayload) => {
	const response = await axiosInstance.post(
		"/guests/password_recovery/verify_code",
		{
			...payload,
		},
	);
	return ZodSentryReporter.parse(VerifyCodeResponseSchema, response);
};

export type ResetPasswordPayload = {
	password: string;
	token: string;
};

export const resetPassword = async (payload: ResetPasswordPayload) => {
	const response = await axiosInstance.post(
		"/guests/password_recovery/reset",
		{
			...payload,
		},
		{
			headers: {
				Authorization: `Bearer ${payload.token}`,
			},
		},
	);
	return ZodSentryReporter.parse(VerifyCodeResponseSchema, response);
};
